import { render, staticRenderFns } from "./SiteTypeIntervalSetup.vue?vue&type=template&id=ca648dec&scoped=true&"
import script from "./SiteTypeIntervalSetup.vue?vue&type=script&lang=js&"
export * from "./SiteTypeIntervalSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca648dec",
  null
  
)

export default component.exports